import { Methods, RestClient } from 'o2o_layout/lib/common/rest';
import { BIGDATA_CONSTANT } from '../../../../../common/constant';
import { TPayloadSaveTermPangoConfig } from './type';

const SaveTermPangoConfig = (payload: TPayloadSaveTermPangoConfig) => {
  let url = BIGDATA_CONSTANT.url.account + `api/mngmnt/platform/config/term/save`;
  var restClient = new RestClient(Methods.POST, url);
  return new Promise((resolve, reject) => {
    restClient.execute({}, payload).then(
      (response: any) => {
        const user: any = response.data;
        resolve(user);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export default SaveTermPangoConfig;
